import { IAppState } from 'shared/common/state';

export function selectNewbuildingBrokerSelfRequestFormWidgetActive(state: IAppState) {
  return state.newbuildingBrokerSelfRequestFormWidget.active;
}
